import React from "react";
import PersonView from "./PersonView";
import DateRangeRenderer from "./renderers/DateRangeRenderer";

interface RoommateViewProps
{
    data: RoomMate;
}

// Wraps the existing PersonView (name + photo) and always shows this roommate's own
// contract dates alongside it, even when they match the address's own date range -
// keeps the roommate's actual assignment period visible regardless.
export default class RoommateView extends React.Component<RoommateViewProps>
{
    render(): React.ReactNode
    {
        const { data } = this.props;

        if (!data)
            return null;

        return <div className={"roommate-item"}>
            <PersonView data={data as any} />
            <div className={"grayText small"} style={{ paddingLeft: "32px" }}>
                <DateRangeRenderer fromDate={data.fromDate} thruDate={data.thruDate} />
            </div>
        </div>;
    }
}
